import { render, staticRenderFns } from "./Distribution.vue?vue&type=template&id=4cb50f59&scoped=true&"
import script from "./Distribution.vue?vue&type=script&lang=js&"
export * from "./Distribution.vue?vue&type=script&lang=js&"
import style0 from "./Distribution.vue?vue&type=style&index=0&id=4cb50f59&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb50f59",
  null
  
)

export default component.exports